import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { authHeader } from '../helper/authHeader';
import { API_PATH }  from '../config';
import MomentUtils from "@date-io/moment";
import { Grid, Paper, Box, Table, TableContainer, TableHead, TableBody, TableCell, TableRow, CircularProgress, Button, TextField } from '@material-ui/core';
import { FormControl, InputLabel, Select, MenuItem, Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';
import AlertBox from './AlertBox';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import grey from "@material-ui/core/colors/grey";

import { stationListRequest } from '../actions/stationQueryAction';
import { stationUploadFileListRequest, stationUploadFileAddRequest, stationUploadFileDeleteRequest } from '../actions/stationUploadFileAction';
import { ContactSupportOutlined } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    select: {
        paddingTop: theme.spacing(3),
        backgroundColor: 'white'
    },
    selectMenu: {
        fontSize: '1rem',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#AED6F1',
        //        color: theme.palette.common.white,
        fontSize: 20,
        border: '1px solid #ABB2B9'
    },
    body: {
        fontSize: 16,
        //        verticalAlign: 'baseline',
        border: '1px solid #ABB2B9',
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const StationUploadFile = () => {
    const style = useStyles();
    const dispatch = useDispatch();
    const stationList = useSelector(state => state.stationList);
    const uploadFileList = useSelector(state => state.stationUploadFile);
    const [alert, setAlert] = useState({});
    const [pageInfo, setPageInfo] = useState({ page: 1, pageSize: 10, pageCount: 0 });
    const [pageCount, setPageCount] = useState(0);
    const [stations, setStations] = useState([]);
    const [selectStation, setSelectStation] = useState('');
    const [openNew, setOpenNew] = useState(false);
    const [newData, setNewData] = useState({ file: '', description: '' });

    useEffect(() => {
        if (stationList && stationList.stations && stationList.stations.length > 0) {

            setStations(stationList.stations);
            setSelectStation(stationList.stations[0].ID);
        } else {
            if (!stationList || stationList.status === 0) {
                dispatch(stationListRequest());
            }
        };
    }, [stationList, dispatch]);


    useEffect(() => {
        if (selectStation)
            dispatch(stationUploadFileListRequest(selectStation));
    }, [selectStation]);


    useEffect(() => {
        if (uploadFileList && uploadFileList.status === 3) {
            setAlert({ open: true, type: 'error', text: uploadFileList.error });
        }
    }, [uploadFileList])

    const onAddSaveClicked = (event) => {
        event.preventDefault();

        console.log(selectStation);

        if (!newData.file) {
            setAlert({ open: true, type: 'error', text: '尚未選取上傳檔案 !' });
            return;
        }


        let data = new FormData();
        data.append('file', newData.file);
        data.append('description', newData.description);
        data.append('station_id', Number(selectStation));

        dispatch(stationUploadFileAddRequest(data));

    }

    const onDeleteClicked = (event, id) => {
        event.preventDefault();
        if (window.confirm("確定刪除 ?")) {
            dispatch(stationUploadFileDeleteRequest(selectStation, id));
        }
    }

    const handleDownload = (id, filename) => {
        axios.get( `${API_PATH}/station/file_download?id=${id}`,
            {
                headers: { ...authHeader() },
                timeout: 5000,
                responseType: 'blob',
            })
            .then((res) => {
                fileDownload(res.data, filename)
            }).catch((err) => {
                    console.error(err);
                    setAlert({ open: true, type: "error", text: '無法取得檔案'});
                })
    }

    return (
        <Box m={5}>
            <AlertBox open={alert.open} type={alert.type} text={alert.text} close={() => setAlert({ ...alert, open: false })}></AlertBox>
            <Box width="95%" style={{ margin: '0 auto', minWidth: 900 }}>
                <Box my={2}>
                    <FormControl className={style.select} style={{ minWidth: 300 }}>
                        <InputLabel style={{ fontSize: 20, padding: 5 }}>選取案場</InputLabel>
                        <Select classes={{ selectMenu: style.selectMenu }} variant="filled"
                            value={selectStation}
                            onChange={(e) => setSelectStation(e.target.value)}
                        >
                            {stations && stations.length > 0 && stations.map((x, i) => (
                                <MenuItem key={i} value={x.ID}>{`${x.ID} - ${x.Name}`}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell width="35%">檔案名稱</StyledTableCell>
                                <StyledTableCell width="45%">說明</StyledTableCell>
                                <StyledTableCell width="15%">上傳時間</StyledTableCell>
                                <StyledTableCell width="5%"></StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <StyledTableRow style={{ backgroundColor: 'white' }}>
                                <StyledTableCell style={{ verticalAlign: 'top' }}>
                                    <TextField variant="outlined" type="file" fullWidth={true}
                                        onChange={(e) => { setNewData({ ...newData, file: e.target.files[0] }) }} />
                                </StyledTableCell>
                                <StyledTableCell colSpan={3} style={{ whiteSpace: "pre-wrap" }}>
                                    <Box>
                                        <TextField variant="outlined" fullWidth={true}
                                            value={newData.description} onChange={(e) => { setNewData({ ...newData, description: e.target.value }) }} />
                                    </Box>
                                    <Box mt={2}>
                                        <Button variant="contained" color="primary" onClick={(e) => onAddSaveClicked(e)}>新 增</Button>
                                    </Box>
                                </StyledTableCell>
                            </StyledTableRow>
                            {uploadFileList.status === 1 ?
                                <StyledTableRow>
                                    <StyledTableCell align="center" colSpan={4}><CircularProgress color="secondary" thickness={6} /></StyledTableCell>
                                </StyledTableRow>
                                :
                                uploadFileList.result && uploadFileList.result.length > 0 ?
                                    uploadFileList.result.map((x, i) => (
                                        <StyledTableRow key={i}>
                                            <StyledTableCell style={{ whiteSpace: "nowrap" }}>
                                                <Button variant="outlined" color="primary"
                                                    onClick={() => handleDownload(x.ID, x.Filename)}>{x.Filename}</Button>
                                            </StyledTableCell>
                                            <StyledTableCell>{x.Description}</StyledTableCell>
                                            <StyledTableCell>{x.UploadTime && moment(x.UploadTime).format('YYYY-MM-DD hh:mm:ss')}</StyledTableCell>
                                            <StyledTableCell>
                                                <Button variant="contained" size="small" color="primary" onClick={(e) => onDeleteClicked(e, x.ID)}>刪除</Button>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))
                                    :
                                    <StyledTableRow>
                                        <StyledTableCell align="center" colSpan={5}>沒有資料</StyledTableCell>
                                    </StyledTableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
};

export default StationUploadFile;